module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-content-inner bricks"
  }, [_c('h2', {
    staticClass: "main-headline"
  }, [_vm._v("YOUR PROJECT. YOUR VISION.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "back-button",
    attrs: {
      "tag": "a",
      "to": "/products"
    }
  }, [_vm._v("\n                        Back to products\n                    ")]), _vm._v(" "), _c('strong', {
    staticClass: "click-line"
  }, [_vm._v("Click any brick to view our Virtual Brick Feature!")]), _vm._v(" "), _c('ul', {
    staticClass: "bricks-list"
  }, [_c('li', [_c('div', {
    staticClass: "bricks-info"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/virtual/regimental-red-brick"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Products-Page/bricksregred.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v("REGIMENTAL RED BRICK")])])], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
    staticClass: "with-description"
  }, [_c('div', {
    staticClass: "bricks-info"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/virtual/claret-full-range-brick"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Products-Page/bricksclaret.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v("CLARET FULL RANGE BRICK")]), _vm._v(" "), _c('span', [_vm._v("Claret Full Range will vary in color from dark red to brown")])])], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "bricks-info"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/virtual/medium-ironspot-brick"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Products-Page/bricksmediron.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v("MEDIUM IRONSPOT BRICK")])])], 1), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "bricks-info"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/virtual/frs-black-granite-brick"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Products-Page/bricksgranite.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v("FRS BLACK GRANITE BRICK ")])])], 1), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "bricks-info"
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/virtual/frs-black-granite-brick-12x12"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/Products-Page/bricks12x12granite.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v("FRS BLACK GRANITE BRICK")])])], 1), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "subheadline"
  }, [_vm._v("With over 30+ years of experience, Fund Raisers, Ltd. has hand selected\n                        "), _c('br'), _vm._v(" each product to ensure that you receive only the best in the industry with\n                        "), _c('br'), _vm._v(" the right balance of quality, aesthetics, and affordability.\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bricks-sizes"
  }, [_c('strong', [_vm._v("4” x 8” x 2 1/4“")]), _vm._v(" "), _c('strong', [_vm._v("8” x 8” x 2 1/4”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bricks-sizes"
  }, [_c('strong', [_vm._v("4” x 8” x 2 1/4“")]), _vm._v(" "), _c('strong', [_vm._v("8” x 8” x 2 1/4”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bricks-sizes"
  }, [_c('strong', [_vm._v("4” x 8” x 2 1/4“")]), _vm._v(" "), _c('strong', [_vm._v("8” x 8” x 2 1/4”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bricks-sizes"
  }, [_c('strong', [_vm._v("4” x 8” x 2“")]), _vm._v(" "), _c('strong', [_vm._v("8” x 8” x 2”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bricks-sizes"
  }, [_c('strong', [_vm._v("12” x 12” x 2”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', {
    staticClass: "title-line"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', [_vm._v("DON’T FORGET!")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sublist"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": "images/Products-Page/products8.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v("FREE MARKETING BRICK")]), _vm._v(" "), _c('span', [_vm._v("A great marketing tool to connect your product to your supporters.")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "images/Products-Page/products9.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v("BLANK BRICKS")]), _vm._v(" "), _c('span', [_vm._v("A one-stop shop! Order blank bricks to complete your project.")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "images/Products-Page/products10.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v("REPLICA BRICKS")]), _vm._v(" "), _c('span', [_vm._v("An extra source of revenue that can be enjoyed in your home or office.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4676454c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/Bricks.vue
// module id = Y2nm
// module chunks = 1